import { useLocation } from 'react-router-dom';
import { ReactNode, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { usePrefersReducedMotion } from '@/hooks/useMediaQuery';
import { EASE_OUT, DUR } from './motion';

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const prefersReducedMotion = usePrefersReducedMotion();

  // Track whether this is the initial mount so we can skip the enter animation
  // on the very first render (no need to animate the first page load).
  const isInitialMount = useRef(true);

  if (prefersReducedMotion) {
    return <div className="h-full">{children}</div>;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        className="h-full"
        initial={isInitialMount.current ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: DUR.standard, ease: EASE_OUT }}
        onAnimationComplete={() => {
          isInitialMount.current = false;
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
